export enum TailwindBreakpointsEnum {
    XS ='xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    TWO_XL = '2xl',
}
